module.exports = __webpack_public_path__ + "img/026.70191012.png";